import { useEffect, useState } from 'react'
import { isEqual } from 'lodash'
import usePrevious from './usePrevious'

const useFormHooks = (initialState = {}, onSubmit = () => {}) => {
  const [inputs, setInputs] = useState(initialState)
  const previousInitialState = usePrevious(inputs)
  useEffect(() => {
    if (!isEqual(inputs, previousInitialState)) {
      setInputs(inputs)
    }
  }, [inputs, previousInitialState])

  const handleSubmit = event => {
    if (event) {
      event.preventDefault()
      onSubmit()
    }
  }

  const handleInputChange = event => {
    event.persist()
    setInputs(input => ({ ...input, [event.target.name]: event.target.value }))
  }

  const clearInputs = () => {
    Object.keys(inputs).forEach(field => setInputs(input => ({ ...input, [field]: '' })))
  }

  return {
    handleSubmit,
    handleInputChange,
    inputs,
    setInputs,
    clearInputs,
  }
}

export default useFormHooks
